import Raven from 'raven-js';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
export const getSavedLockedFeatureUpgradeKey = () => {
  try {
    return localStorage.getItem('HS_GROWTH_LAST_LOCKED_FEATURE');
  } catch (_unused) {
    Raven.captureMessage('failed to retrieve upgrade key from local storage');
    return null;
  }
};
export const saveLockedFeatureInteractionOnLocalStorage = (upgradeKey, apiName) => {
  const isSuiteStarterLockedFeature = apiName === CRM_SUITE_STARTER_BUNDLE;
  if (isSuiteStarterLockedFeature) {
    try {
      localStorage.setItem('HS_GROWTH_LAST_LOCKED_FEATURE', `${upgradeKey}`);
    } catch (_unused2) {
      Raven.captureMessage('failed to save upgradeKey in local storage');
    }
  }
};